export default function PHP_function() {
  return (
    <div>
      <h1>PHP_function</h1>
    </div>
  );
}
